import { CSVLink } from "react-csv";
import SqlTemplatesService from "@app/services/http/sql-templates.service";
import { useState } from "react";
import ExecuteIcon from "@app/icons/execute";
import ExportIcon from "@app/icons/export";

interface ButtonsProps {
  csvData: any[];
  setCSVData: (data: any[]) => void;
  setQuery: (query: string) => void;
  setHeaders: (headers: string[]) => void;
  setRows: (rows: any[]) => void;
  value: string;
  onExecuteSuccess: (success: boolean) => void;
}

function Buttons({
  csvData,
  setCSVData,
  setQuery,
  setHeaders,
  setRows,
  value,
  onExecuteSuccess,
}: ButtonsProps) {
  const [isLoading, setIsLoading] = useState(false);

  const runQuery = async () => {
    try {
      setIsLoading(true);
      setQuery(value);
      onExecuteSuccess(false);

      const response = await SqlTemplatesService.execute({
        sqlStatement: value,
      });

      if (response.data) {
        const { items } = response.data;

        setRows(items || []);

        if (items?.length > 0) {
          const headers = Object.keys(items[0]);

          setHeaders(headers);
          setCSVData(items);
          onExecuteSuccess(true);
        } else {
          setHeaders([]);
          setCSVData([]);
          onExecuteSuccess(false);
        }
      }
    } catch (error) {
      onExecuteSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex">
      <div className="p-2">
        <button
          onClick={runQuery}
          disabled={isLoading}
          className="flex mx-auto text-white bg-[#00A653] border-0 py-2 h-11 px-4 focus:outline-none hover:bg-[#00A653] rounded-[8px] text-lg justify-center items-center disabled:bg-indigo-300"
        >
          {isLoading ? (
            <div className="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin mr-2" />
          ) : (
            <div className="pr-3">
              <ExecuteIcon />
            </div>
          )}
          <div className="font-[14px]">Execute</div>
        </button>
      </div>
      <div className="flex w-full justify-between mt-6 lg:mt-0">
        <CSVLink
          data={csvData}
          filename={new Date().getTime().toString() + ".csv"}
          className="p-2"
        >
          <button
            className="flex mx-auto text-[#8495AC] bg-white border-[2px] border-[#5A82D7] py-2 h-11 px-4 focus:outline-none rounded-[8px] text-lg justify-center items-center"
            disabled={isLoading || csvData.length === 0}
          >
            <ExportIcon />
            <span className="pl-2 font-[14px]">Export</span>
          </button>
        </CSVLink>
      </div>
    </div>
  );
}

export default Buttons;
